import { useState, FormEvent, useEffect } from "react";
import { useLocation } from "wouter";
import { useAdminAuth } from "@/lib/adminAuth";
import { Seo } from "@/lib/seo";

function errMsg(e: unknown): string {
  return e instanceof Error ? e.message : "Invalid credentials";
}
export default function AdminLogin() {
  const { login, isAuthenticated } = useAdminAuth();
  const [, setLocation] = useLocation();

  useEffect(() => {
    if (isAuthenticated) setLocation("/admin");
  }, [isAuthenticated, setLocation]);
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e: FormEvent) => {
    e.preventDefault();
    setError("");
    setLoading(true);
    try {
      await login(email, password);
      setLocation("/admin");
    } catch (err: unknown) {
      setError(errMsg(err));
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen bg-[#0a0a0f] flex items-center justify-center p-4">
      <Seo
        title="Admin Login | AgentsToGo"
        description="AgentsToGo admin login."
        path="/admin/login"
        noindex
      />
      <div className="w-full max-w-sm">
        <div className="flex justify-center mb-8">
          <span className="text-white text-2xl font-light tracking-tight">
            agents<span className="font-bold">to</span>go<span className="text-blue-400 font-bold">.</span>
          </span>
        </div>
        <div className="bg-white/5 border border-white/10 rounded-2xl p-8 backdrop-blur-md">
          <h1 className="text-xl font-semibold text-white text-center mb-6">Admin Portal</h1>
          <form onSubmit={handleSubmit} className="space-y-4">
            <div>
              <label htmlFor="admin-email" className="block text-sm text-white/60 mb-1">Email</label>
              <input
                id="admin-email"
                type="email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                className="w-full bg-white/10 border border-white/20 rounded-lg px-4 py-2.5 text-white placeholder-white/30 focus:outline-none focus:border-purple-500 transition"
                placeholder="admin@example.com"
                required
                autoFocus
              />
            </div>
            <div>
              <label htmlFor="admin-password" className="block text-sm text-white/60 mb-1">Password</label>
              <input
                id="admin-password"
                type="password"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                className="w-full bg-white/10 border border-white/20 rounded-lg px-4 py-2.5 text-white placeholder-white/30 focus:outline-none focus:border-purple-500 transition"
                placeholder="••••••••"
                required
              />
            </div>
            {error && <p className="text-red-400 text-sm">{error}</p>}
            <button
              type="submit"
              disabled={loading}
              className="w-full bg-purple-600 hover:bg-purple-500 disabled:opacity-60 text-white font-medium py-2.5 rounded-lg transition"
            >
              {loading ? "Signing in…" : "Sign In"}
            </button>
          </form>
        </div>
        <p className="text-center text-white/30 text-xs mt-6">
          AgentsToGo — Admin Access Only
        </p>
      </div>
    </div>
  );
}
